export default __webpack_public_path__ + "static/media/amazonas1.2965bb0e.jpg";